module.exports = "<span class=\"igx-icon\" [class.igx-icon--inactive]=\"!getActive\">\n    <i #icon *ngIf=\"getFontSet == 'material'\" class=\"material-icons\">\n        {{ getIconName }}\n    </i>\n</span>"


//////////////////
// WEBPACK FOOTER
// ./src/icon/icon.component.html
// module id = 57
// module chunks = 0 1